jQuery(document).ready(function ($) {
    $('a[href^="#contact-us"]').on('click', function () {

        let href = $(this).attr('href');

        $('html, body').animate({
            scrollTop: $(href).offset().top
        });
        return false;
    });

});


document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('.show-more-benefits').addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector('.hide-benefits').classList.toggle('active');
        this.textContent = this.textContent === 'Show more' ? 'Hide' : 'Show more';
    });
});

document.addEventListener('DOMContentLoaded', function () {

    document.addEventListener('click', function (e) {

        const faqElement = e.target.closest('.faq-list-item');

        if (!faqElement) return true;

        const isClosed = !faqElement.classList.contains('active');
        const faqElements = document.querySelectorAll('.faq-list-item');

        for (let i = 0, n = faqElements.length; i < n; i++) {
            faqElements[i].classList.remove('active');
        }

        if (isClosed) faqElement.classList.add('active');
    });

});
